import { PaymentSubmittedModal } from './PaymentSubmitedModal';

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
  closeButtonText?: string;
}

export function PaymentSubmittedModalContainer({
  open,
  onClose,
  title,
  description,
  closeButtonText,
}: Props) {
  // const { openModal } = useModal();
  return (
    <PaymentSubmittedModal
      open={open}
      onClose={onClose}
      closeButtonText={closeButtonText}
      onCreateNewTask={() => {
        onClose();
        // openModal('taskCreation');
      }}
      title={title}
      description={description}
    />
  );
}
